<script lang="ts">
	import { BackToTop, Favicons, Footer, Navbar, PageTransition, Styles } from '$lib/components';
	import GoogleTagManager from '$lib/components/analytics/GoogleTagManager.svelte';
	import RSSFeed from '$lib/components/RSSFeed/RSSFeed.svelte';
	import SetDefaultTheme from '$lib/components/Theme/SetDefaultTheme.svelte';
	import { setContents } from '$lib/stores/contents.svelte.js';
	import { setTheme } from '$lib/stores/theme.svelte.js';

	const { data, children } = $props();
	setTheme(data.theme);
	setContents(data.contents);
</script>

<GoogleTagManager key={data.googleTagManager} />
<SetDefaultTheme />
<Styles />
<Favicons appName={data.app.name} />
<PageTransition />
<BackToTop />
<RSSFeed link="/rss.xml" />
<a href="#main" class="sr-only focus:not-sr-only">Skip to main content</a>
<div id="main" class="app p-1 sm:p-3 py-3">
	<Navbar user={data.user} name={data.app.name} slogan={data.app.slogan} />
	<main class="flex-1">
		{#if children}
			{@render children()}
		{/if}
	</main>
	<Footer
		appName={data.app.name}
		appUrl={data.app.url}
		appPhone={data.app.phone}
		appEmail={data.app.email}
		facebook={data.facebook}
		instagram={data.instagram}
		tripadvisor={data.tripadvisor}
	/>
</div>
